import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from "../components/ReactNativeAppDevelopment/Hero";
import DevelopServices from "../components/ReactNativeAppDevelopment/DevelopServices";
import Technology from "../components/ReactNativeAppDevelopment/Technology";
import Process from "../components/ReactNativeAppDevelopment/Process";
import IndustryBussinessjs from "../components/ReactNativeAppDevelopment/IndustryBussinessjs";
import Commitment from "../components/ReactNativeAppDevelopment/Commitment";
import Customers from "../components/ReactNativeAppDevelopment/Customers";
import Success from "../components/ReactNativeAppDevelopment/Success";
import PageTitle from "../components/ReactNativeAppDevelopment/PageTitle";

import '../assets/Webdevelopment.css';



const ReactNativeAppDevelopment = () => {
	return(
		<div className="App">
			<PageTitle />
	    	<Hero />
	    	<DevelopServices />
	    	<Technology />
	    	<Process />
	    	<IndustryBussinessjs />
	    	<Commitment />
	    	<Customers/>
	    	<Success />
	  </div>
	)
}

export default ReactNativeAppDevelopment;
